export enum ReportTableActionMenuTypesEnum {
    Buttons,
    Links
}
